import React, { useState } from 'react';
import { useNavigate,Link } from 'react-router-dom';

import axios from 'axios';
import Swal from 'sweetalert2';
import { useForm } from 'react-hook-form';
import logo from '../../assets/logo.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

const Login = () => {
  const { register, handleSubmit, formState: { errors, isSubmitting } } = useForm();
  const navigate = useNavigate();
  const [role, setRole] = useState('1'); // Default role is HR
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const onSubmit = (data) => {
    setIsLoading(true);
    
    const payload = {
        Email: data.email,
        Password: data.password,
        RoleID: role,
    };

    axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/login`, payload)
      .then(response => {
        setIsLoading(false);
        if (response.data.message === 'Invalid email or password') {
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'Email or password is incorrect',
            showConfirmButton: false,
            timer: 3000
          });
        } else if (response.data.message === 'Invalid password') {
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'Please check Password',
            showConfirmButton: false,
            timer: 3000
          });
        } else if (response.data.message === 'Role is incorrect') {
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'Please check Role',
            showConfirmButton: false,
            timer: 3000
          });
          
        }else if(response.data.message=='Please verify your account'){
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'Please verify your account by clicking the link in your email.',
            showConfirmButton: false,
            timer: 3000
          });
        } else if (response.data.message == 'success') {
        // role ==1 ? navigate("/Home") : navigate("/Adminhome");
        if(role ==1){
          response.data.IsActive ? navigate("/Home") : navigate("/subscription")  
        }else if (role ==2){
          response.data.IsActive ? navigate("/Adminhome") : navigate("/subscription")
        }else if (role ==4){
            response.data.IsActive ? navigate("/Pagehome") : navigate("/subscription")
        }
        role==3 && navigate("/listofusers")
          localStorage.setItem("guid",(response.data.Guid));
          localStorage.setItem("UserID",(response.data.UserID));
          localStorage.setItem("RoleID",role);
          localStorage.setItem("ClientID",response.data.ClientId);
          localStorage.setItem("IsActive", response.data.IsActive);
          localStorage.setItem("CreatedDate", response.data.CreatedDate);
          localStorage.setItem("UserEmail", response.data.Email);
          localStorage.setItem("subscriptionStartDate", response.data.subscriptionStartDate);
          localStorage.setItem("subscriptionEndDate", response.data.subscriptionEndDate);
          localStorage.setItem("UserName", response.data.UserName);
          localStorage.setItem("SubscriptionType", response.data.SubscriptionType);
          localStorage.setItem("lastLoginTime", response.data.lastLoginTime);
          localStorage.setItem("ReferralCode", response.data.ReferralCode || '');
          localStorage.setItem("CountryCode", response.data.CountryCode);

          console.log("dateee", response.data.subscriptionEndDate);
          
          // Refresh feature limits data after successful login
          if (window.refreshFeatureUsage) {
            window.refreshFeatureUsage();
          }
      
role ==1 && localStorage.setItem("AccountType","User") ;
role ==4 && localStorage.setItem("AccountType","Page")

        }
      })
      .catch(error => {
        setIsLoading(false);
        console.error('Error logging in:', error);
      });
  };

  return (
    <>

      <section className="vh-100">
        {isLoading ? <div className="spinner"></div> :
          <>
          <Link to="/LandingPage">
           <img
                  src={logo} style={{ height: '80px',  margin: 15 }} alt="Logo"
                />
                </Link>
 <div className="container h-custom">

  <div className="row d-flex justify-content-center align-items-center mt-4">
    <div className="col-sm-12 col-lg-6 col-xl-6 col-md-6">
      <img
        src="https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-login-form/draw2.webp"
        className="img-fluid"
        alt="Sample" />
    </div>
    <div className="col-sm-12 col-lg-6 col-xl-6 col-md-6">
      <div className="card shadow-lg p-5" style={{ border: 'none' }}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <label className="form-label text-center">Role</label>
          <div className="d-flex flex-direction-row justify-content-center align-items-center form-outline mb-4">
            <div className="radio-container" style={{marginRight:30}}>
              <input
                type="radio"
                id="hrRole"
                name="role"
                value="0001"
                checked={role === '1'}
                style={{
                  transform: 'scale(1.25)',  // Increases the size of the radio button itself
                  marginRight: '10px',  // Optional: Adds some space between the radio button and the label
                }}
                onChange={() => setRole('1')} />
              <p htmlFor="hrRole">Personal Branding</p>
            </div>
            <div className="radio-container" style={{marginRight:30}}>
              <input
                type="radio"
                id="hrRole"
                name="role"
                value="0004"
                style={{
                  transform: 'scale(1.25)',  // Increases the size of the radio button itself
                  marginRight: '10px',  // Optional: Adds some space between the radio button and the label
                }}
                checked={role === '4'}
                onChange={() => setRole('4')} />
              {/* <p htmlFor="hrRole">Page</p> */}
              <p htmlFor="hrRole">Business Branding</p>

            </div>
         
            <div className="radio-container">
              <input
                type="radio"
                id="accountantRole"
                name="role"
                value="0002"
                style={{
                  transform: 'scale(1.25)',  // Increases the size of the radio button itself
                  marginRight: '10px',  // Optional: Adds some space between the radio button and the label
                }}
                checked={role === '2'}
                onChange={() => setRole('2')} />
              <p htmlFor="accountantRole">Agency</p>
            </div>
            {/* <div className="radio-container" style={{marginLeft:30}}>
              <input
                type="radio"
                id="hrRole"
                name="role"
                value="0003"
                checked={role === '3'}
                onChange={() => setRole('3')} />
              <p htmlFor="hrRole">SuperAdmin</p>
            </div> */}
          </div>

          <div className="form-outline mb-4">
            <label className="form-label" htmlFor="form3Example3">
              Email address
            </label>
            <input
              type="email"
              id="form3Example3"
              className={`form-control form-control-lg ${errors.email ? 'is-invalid' : ''}`}
              placeholder="Enter a valid email address"
              {...register('email', { 
                required: 'Email is required', 
                pattern: {
                  value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                  message: 'Invalid email address'
                }
              })}
            />
            {errors.email && <div className="invalid-feedback">{errors.email.message}</div>}
          </div>

          <div className="form-outline mb-3">
  <label className="form-label fw-bold" htmlFor="form3Example4">Password</label>

  <div className="input-group">
    <input
      type={showPassword ? 'text' : 'password'}
      id="form3Example4"
      className={`form-control form-control-lg border-end-0 ${errors.password ? 'is-invalid' : ''}`}
      placeholder="Enter password"
      {...register('password', { required: 'Password is required' })}
    />
    
    <span
      className="input-group-text border-start-0"
      style={{ cursor: 'pointer', backgroundColor: 'transparent' }}
      onClick={() => setShowPassword(prev => !prev)}
    >
      <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
    </span>
  </div>

  {errors.password && (
    <div className="invalid-feedback d-block">
      {errors.password.message}
    </div>
  )}
</div>






          <div className="text-center d-flex justify-content-between text-lg-start mt-4 pt-2">
<button
type="submit"
className="btn btn-primary"
disabled={isSubmitting}
style={{ backgroundColor: '#2e3192',borderRadius:8 }}
>
Login
</button>
<Link to='/Register'>
<p style={{color:'#000',marginTop:'20px'}}><b>Register?</b></p>
</Link>
</div>
<div className='text-center mt-5'>
<Link to='/forgotpassword'>
<p style={{color:'#2e3192',fontWeight:'500'}}>Forgot password</p>
</Link>
<Link to='/changepassword'>
<p style={{color:'#2e3192',fontWeight:'500'}}>Change password</p>
</Link>
</div>
        </form>
      </div>
    </div>
  </div>
</div>

          </>
        }
      </section>
    </>
  );
};

export default Login;
